import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const TRIGGER_ID = 'iso-loop-scroll-control'
const ringStepUnits = 1668

function getStepPx(svg) {
  const viewBox = svg.viewBox?.baseVal
  if (!viewBox || !viewBox.width) return 0

  const widthPx = svg.getBoundingClientRect().width
  if (!widthPx) return 0

  return (widthPx / viewBox.width) * ringStepUnits
}

function isoLoop() {
  const container = document.getElementById('iso-loop')
  if (!container) return

  const svg = container.querySelector('svg')
  if (!svg) return

  const prevState = container.__isoLoopState
  if (prevState) {
    if (prevState.control) prevState.control.kill()
  }

  const prevTrigger = ScrollTrigger.getById(TRIGGER_ID)
  if (prevTrigger) prevTrigger.kill()

  let stepPx = getStepPx(svg) || container.offsetHeight * 0.75
  const scrollFactor = 0.15
  let offsetY = 0
  let lastScrollY = window.scrollY

  svg.style.setProperty('--iso-loop-y', '0px')

  const control = ScrollTrigger.create({
    id: TRIGGER_ID,
    trigger: document.documentElement,
    start: 'top top',
    end: 'bottom bottom',
    invalidateOnRefresh: true,
    onRefresh: () => {
      stepPx = getStepPx(svg) || container.offsetHeight * 0.75
      offsetY = gsap.utils.wrap(-stepPx, 0, offsetY)
      svg.style.setProperty('--iso-loop-y', `${offsetY}px`)
      lastScrollY = window.scrollY
    },
    onUpdate: () => {
      const currentScrollY = window.scrollY
      const deltaScroll = currentScrollY - lastScrollY
      if (!deltaScroll) return

      offsetY -= deltaScroll * scrollFactor
      offsetY = gsap.utils.wrap(-stepPx, 0, offsetY)
      svg.style.setProperty('--iso-loop-y', `${offsetY}px`)
      lastScrollY = currentScrollY
    },
  })

  container.__isoLoopState = {
    control,
  }
}

export default isoLoop
